import {WarningIcon} from '@bettermarks/bm-ui-components';
import {ComponentStyleConfig} from '@chakra-ui/react';

export const Heading: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: '600',
    lineHeight: 'inherit'
  },
  sizes: {
    xl: {
      fontSize: '50px'
    },
    md: {
      fontSize: '20px',
      lineHeight: '28px'
    }
  },
  variants: {
    h2: {
      fontSize: '14px',
      lineHeight: '20px'
    }
  }
};
